<template>
  <div class="container" :class="{
    sent: message.author === 'me'
  }">
    <IconEdit
      :message="message"
      @editAnswer="editAnswer"
    />

    <div class="sc-message--text" :style="messageColors">
      <p class="sc-message--text-content" v-html="messageText"></p>
      <p v-if="message.data.meta" class='sc-message--meta' :style="{color: messageColors.color}">{{message.data.meta}}</p>
      <span
        class="tip"
        v-if="tipMessage && modalTitle && modalBody"
        v-tooltip="tipMessage"
        :style="{ backgroundColor: chatbotColors.sentMessage.bg, color: chatbotColors.sentMessage.text }"
        @click.prevent="openDefaultModal(modalTitle, modalBody)"
      >
        ?
      </span>
    </div>
    <div class="options-container">
      <button
        type="button"
        class="inline-option"
        v-for="(inlineOption, idx) in inlineOptions"
        :style="{color: messageColors.color}"
        :key="`text-message-inline-option-${idx}`"
        :disabled="lastMessage === false"
        @click.prevent="handleButton(inlineOption)"
      >
        [ {{ inlineOption.text }} ]
      </button>
    </div>
  </div>
</template>

<script>
import IconEdit from "../components/IconEdit.vue";
import escapeGoat from 'escape-goat'
import store from "./../store/"

export default {
  components: {
    IconEdit
  },
  data() {
    return {
      store,
      tipMessage: null,
      modalTitle: null,
      modalBody: null,
      inlineOptions: [],
    }
  },
  props: {
    message:{
      type: Object,
      required: true
    },
    messageColors: {
      type: Object,
      required: true
    },
    messageStyling: {
      type: Boolean,
      required: true
    },
    chatbotColors: {
      type: Object,
      required: true
    },
    lastMessage: {
      type: Boolean,
      default: true
    },
  },
  computed: {
    messageText() {
      const escaped = this.me && !this.message.bot
        ? escapeGoat.escape(this.message.data.text)
        : this.message.data.text;

      return escaped;
    },
    me(){
      return this.message.author === 'me';
    }
  },
  mounted () {
    const metadata = this.message.data.metadata;

    if (metadata && metadata.tip) {
      this.tipMessage = metadata.tip.tipMessage;
      this.modalTitle = metadata.tip.modalTitle;
      this.modalBody  = metadata.tip.modalBody;
    }

    if (metadata && metadata.inlineOptions) {
      this.inlineOptions = metadata.inlineOptions;
    }

    if (metadata && metadata.yupin_show_checkout_credit_card) {
      window.EventBus.$emit('YUPIN_SHOW_CHECKOUT_CREDIT_CARD');
    }

    if (metadata && metadata.yupin_close_checkout_credit_card) {
      window.EventBus.$emit('YUPIN_CLOSE_CHECKOUT_CREDIT_CARD');
    }

    const respostaPadrao = this.$store.state.respostaPadrao;

    if (respostaPadrao) {
      window.EventBus.$emit('ON_CONTINUE_TYPING');
      this.$emit('hideMessage');
      return;
    }
  },
  methods: {
    openDefaultModal (title, body) {
      window.EventBus.$emit('OPEN_DEFAULT_MODAL', { title, body });
    },
    handleButton (inlineOption) {
      if (this.lastMessage === false) {
        return;
      }

      window.EventBus.$emit('ON_MESSAGE_WAS_SENT', {
        author: 'me',
        type: 'text',
        data: {...inlineOption}
      });
    },
    editAnswer () {
      window.EventBus.$emit('EDIT_ANSWER', {
        fluxoInteracaoToken: this.message.editarFluxoInteracaoToken
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}
.sent {
  justify-content: flex-end;
  gap: 10px;
}
.sc-message--text-content {
  -webkit-perspective: 0px !important;
  -webkit-backface-visibility: visible !important;
  -webkit-transform: translate3d(0,0,0) !important;
}
a.chatLink {
  color: inherit !important;
}
.options-container {
  width: 100%;
}
.inline-option {
  font-size: 11px;
  border: 0;
  background: transparent;
  cursor: pointer;

  &:hover {
    opacity: .7;
  }

  &:disabled {
    opacity: .3;
    cursor: not-allowed;
  }
}
.tip {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: -25px;
  top: 50%;
  margin-top: -10px;
  width: 20px;
  height: 20px;
  border-radius: 100%;
  font-size: .8rem;
  cursor: pointer;
}
</style>
